import { useOutletContext } from 'react-router'

export type PlatformOutletContext = {
  appId: number
  appKey: string
  projectId: number
  pageId: string
}

export function usePlatformOutletContext() {
  return useOutletContext<PlatformOutletContext>()
}
